'use strict';

var jsxRuntime = require('react/jsx-runtime');

const LargeReset = ({ testId, className })=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: [
            jsxRuntime.jsx("path", {
                d: "M13.1666 8.57143L10.8333 6.28571L13.1666 4",
                stroke: "currentColor",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M12 6.28577C15.866 6.28577 19 9.35581 19 13.1429C19 16.93 15.866 20.0001 12 20.0001C8.13401 20.0001 5 16.93 5 13.1429C5 11.8434 5.36903 10.6283 6.01003 9.5927",
                stroke: "currentColor",
                strokeWidth: "1.4",
                strokeLinecap: "square"
            })
        ]
    });
};

module.exports = LargeReset;
